import React, { useState, useCallback, createContext, useEffect, useReducer, useRef } from 'react';
import { router } from 'umi';
import { reducer, defaultState } from './components/context';
// import {Modal} from 'antd-mobile'
import NavBar from '@/components/NavBar';
import { connect } from 'dva';
import { MovieProps } from '@/entity/module/movie';
import ReStage from './components/ReStage';
import SiteList from './components/SiteList';
import DfModal from '@/components/Modal';
import DfCertificationModal from '@/components/CertificationModal';
import { Modal, Toast } from 'antd-mobile';
import MulPriceArea from './components/MulPriceArea';
import { parseDate, timeAdd, timeToHm } from '@/utils/time';
import rule from '@/utils/rule';
import DfPrice from '@/components/dFPrice';
import {
  unionFlag,
  getSessonStorage,
  setCookie,
  getCookie,
  getQueryString,
  handlePara,
  checkUnifyShop
} from '@/utils';
import useGetSeats from './hooks/useGetSeats';
import useTimeout from './hooks/useTimeout';
import usePostLockSeats from './hooks/usePostLockSeats';
import { verifiedSeatForPurchase } from '@/utils/seat';
import { TLang, ReplaceText, CheckCN } from '@/utils/lang';
import device from '@/utils/device';
import { increaseLoading, decreaseLoading, timer } from '@/public';
import './style/index.less';

const styles = require('./style/index.less');

import notieImg from '@/assets/imgs/notification.png';
const prompt = Modal.prompt;
import Bus from './components/context/bus';
import DFTipsMsg from '@/components/dfTipsMsg';
import PayPassword from './components/PayPassword';
import { sha1 } from '@/utils/SHA2';
import api from '@/common/api';
import PurchaseLimitModal from '@/components/purchaseLImitModal';
import DFWebUtilsTools from '@df-fe/df-web-utils-tools';
import { judgeBrand } from '@/utils/other';
import { BFD_checkApp } from '@/utils/bfdApp';
import DFDiscount from '@/components/dfDiscount';
import EmptyRefer from '@/components/emptyRefer';
import ReStageFloors from './components/ReStageFloors';
import { safeJsonParse } from '@/utils/safeJsonParse';
import { gioClick } from '@/utils/gioApi';

var lockTime;
export const Context = createContext(null); // 私有state
const MovieSeat = (props: MovieProps) => {
  if (!props.movieSession) {
    return null;
  }
  const {
    cinemaName,
    movieName,
    showDateTime,
    hallName,
    duration,
    language,
    dimensional,
    lowPriceTag
  } = props.movieSession;

  const [mobile, setMobile] = useState(''); // 手机号。百福得
  // 百福德
  const unionCode = unionFlag() || getSessonStorage('dffl_union');
  const [union] = useState(unionCode && typeof unionCode !== 'undefined');
  const [passwordInfo, setPasswordInfo] = useState<any>(null);
  // 限购弹框
  const [purchaseLimitModal, setPurchaseLimitModal] = useState(false);
  const [purchaseLimitInfo, setPurchaseLimitInfo] = useState({});
  const [companyOrderType, setCompanyOrderType] = useState(2);
  const [aggOrderH5Url, setAggOrderH5Url] = useState('');
  const [currentFloor, setCurrentFloor] = useState<any>();
  //待支付订单信息
  const [unpayOrderInfo, setUnpayOrderInfo] = useState<any>(null);
  //待支付订单提示弹窗
  const [showOrderPop, setShowOrderPop] = useState(false);
  // 风控账户提示弹窗（200019）
  const [showRiskAccountModal, setShowRiskAccountModal] = useState(false);
  const [riskAccountMessage, setRiskAccountMessage] = useState('');
  // const [seatPrices, setSeatPrices] = useState<any>()
  const { dataSource, leftIndexs, isMulPrice, sortPrices, newData, isEmpty, shadow,
    selSeats,
    setSelSeats } = useGetSeats(
    union,
    props.movieSession,
    currentFloor?.id||''
  );
  useTimeout(() => {
    setTimeoutFlag(true);
  }, 600000); // 1000 * 60 * 10  === 10分钟

  /**
   * 查询用户信息
   */
  const getUserInfo = async () => {
    const union = unionFlag() || getSessonStorage('dffl_union');
    let cookie = window?.df_sdk_common?.getCookieToken('dfflone') || window?.df_sdk_common?.getCookieToken(getQueryString('union'));
    const params = {
      token: cookie,
      smsType: 2,
      sourceSys: union && !checkUnifyShop() ? 4 : 1, // 百福得4，官网1,
      sourceWay: 3,
      // TODO: 是否全量查询
      fullSearch: true
    };
    api.morequery(params).then((res) => {
      if (res?.code === 200 && res?.data) {
        setPasswordInfo(res?.data);
        if (!res?.data?.mobile) {
          // 没有绑定手机号
          setShowBindModal(true);
        }
      }
    });
  };

  useEffect(() => {
    let cityId = 145;
    const localAddress = safeJsonParse(DFWebUtilsTools.getCatchAddress());
    const address = getSessonStorage('currentAddress');
    if (address) {
      cityId =
        localAddress && localAddress?.cityId ? localAddress?.cityId : JSON.parse(address).cityId;
    }
    if (unionCode) {
      api
        .findByUnionConfig({
          union: unionCode,
          city: cityId,
          channel: 1,
          ignore: false,
          unionFlag: union ? 1 : 0
        })
        .then((res) => {
          console.log('findByUnionConfig', res);
          if (res) {
            setCompanyOrderType(res.companyOrderType);
            setAggOrderH5Url(res.aggOrderH5Url);
          }
        });
    }
  }, []);

  useEffect(() => {
    getUnpayInfo();
    const union = unionFlag() || getSessonStorage('dffl_union');
    if (!union) {
      // 查询官网用户有无绑定手机号
      getUserInfo();
    }
  }, []);

  const getUnpayInfo = () => {
    api.getUnPayOrderInfo({}).then((res) => {
      if(res?.orderSn) {
        setUnpayOrderInfo(res);
        setShowOrderPop(true);
        gioClick('电影-选座页面', {
          pagename: '选座页面',
          channle: '电影',
          modulename: '订单提示弹窗',
          elementname: '取消订单',
          contentTitle: res?.cinemaName,
          contentSubTitle: res?.movieName,
          content: res?.showStartTime,
          orderNum: res?.orderSn
        }, 'DF_exposureEvent');
        gioClick('电影-选座页面', {
          pagename: '选座页面',
          channle: '电影',
          modulename: '订单提示弹窗',
          elementname: '去支付',
          contentTitle: res?.cinemaName,
          contentSubTitle: res?.movieName,
          content: res?.showStartTime,
          orderNum: res?.orderSn
        }, 'DF_exposureEvent');
      }
    });
  };

  useEffect(() => {
    try {
      if (process.env.envType === 'prd' && window?.performance && window?.performance?.getEntries()) {
        if (dataSource && Object.keys(dataSource).length > 0) {
          // @ts-ignore
          const DFTracer = window.DFTracer;
          DFTracer.local('电影锁座页面返回数据', function () {
            const tagsParams = {
              title: document.title,
              dataSource: JSON.stringify(dataSource),
              newData: JSON.stringify(newData)
            };
            // 附带的属性
            DFTracer.setTags(tagsParams);
            DFTracer.sendImmediately();
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
    if (dataSource && Object.keys(dataSource).length > 0) {
      Toast.hide();
      if (dataSource.mobile) {
        setMobile(dataSource.mobile);
      }
      if (dataSource?.purchaseLimitDTO) {
        setPurchaseLimitInfo(dataSource?.purchaseLimitDTO);
        setPurchaseLimitModal(!dataSource?.purchaseLimitDTO?.passFlag);
      }
    }
  }, [dataSource]);

  const { requstLockSeats } = usePostLockSeats();

  const [total, setTotal] = useState(0);
  const getSiteHandler = useCallback((e) => {
    let newList = e.slice() || [];
    if (!dataSource?.floors||dataSource?.floors?.length <= 0) {
      newList = newList?.map((t) => ({
          ...t,
          vendorOriginDesc: t.vendorSeatDesc
        }));
      setSelSeats(newList);
      setTotal(getTotalPrice(newList));
      return;
    }
    let floorName = currentFloor?.name || dataSource?.floors?.[0].name || '';
    newList = newList?.map((t) => {
      if (
        t.info.indexOf('层') > -1 ||
        t.info.indexOf('F') > -1 ||
        !floorName
      ) {
        return {
          ...t,
          vendorOriginDesc: t.vendorSeatDesc
        };
      } else {
        return {
          ...t,
          info: floorName + t.info,
          seatDesc: floorName + t.seatDesc,
          vendorOriginDesc:  t.vendorSeatDesc,
          vendorSeatDesc: floorName + t.vendorSeatDesc
        };
      }
    });
    setSelSeats(newList);
    setTotal(getTotalPrice(newList));
    console.log(e);
  }, [dataSource, currentFloor]);

  // 定义超时标志
  const [timeoutFlag, setTimeoutFlag] = useState(false);
  // 定义超时标志
  const [timeoutModal, setTimeoutModal] = useState(false);
  // 实名认证
  const [showCertificationModal, setShowCertificationModal] = useState(false);
  const [isCheckUser, setIsCheckUser] = useState(false);
  const [isShowOrHide, setIsShowOrHide] = useState(false);

  // 绑定手机号弹窗提示
  const [showBindModal, setShowBindModal] = useState(false);

  const getSessionText = () => {
    if (!dataSource?.showDateTime) {
      return null;
    }
    let t = parseDate(dataSource.showDateTime);
    let t2 = timeAdd(dataSource.showDateTime, duration);
    let day: Array<string> = t?.date.split('-');
    let t3 = timeToHm(dataSource.showDateTime);

    return `${t.label}${day[0]}${TLang('月', 'home', false, false, null)}${day[1]}${TLang(
      '日',
      'home',
      false,
      false,
      null,
    )} ${t3}-${t2} ${CheckCN() ? dataSource.language : dataSource.enLanguage}${
      dataSource.dimensional
    }`;
  };
  const getModalText = () => {
    if (!unpayOrderInfo?.showStartTime) {
      return null;
    }
    let t = parseDate(unpayOrderInfo.showStartTime);
    let day: Array<string> = t?.date.split('-');
    let t3 = timeToHm(unpayOrderInfo.showStartTime);
    let t4 = timeToHm(unpayOrderInfo.showEndTime);

    return `${t.label} ${day[0]}${TLang('月', 'home', false, false, null)}${day[1]}${TLang(
      '日',
      'home',
      false,
      false,
      null,
    )} ${t3}-${t4}`;
  };

  const toDeleteSitItem = (item, index) => {
    Bus.emit('deleSeat', index);
  };
  const getTotalPrice = (arr: any) => {
    if (typeof arr === 'undefined') {
      return 0;
    }
    let total = 0;
    arr.forEach((item) => {
      total += item.price;
    });

    return total;
  };
  const goBack = () => {
    if (selSeats.length > 0) {
      setBackModal(true);
    } else {
      backHandle();
      // router.go(-1)
    }
  };
  const [state, cdispatch] = useReducer(reducer, defaultState); // stage 私有reducer
  const backHandle = () => {
    router.go(-1);
  };
  const [backModal, setBackModal] = useState(false);
  const [activeColor, setActiveColor] = useState(-1);
  const colorHandle = useCallback(
    (index) => {
      if (activeColor === index) {
        setActiveColor(-1);
      } else {
        setActiveColor(index);
      }
    },
    [activeColor],
  );

  const clickSelectSeatBtnHandle = () => {
    // 座位空座校验
    const seatFlag = verifiedSeatForPurchase(newData);
    if (!seatFlag) {
      return Toast.info(TLang('座位旁边请不要留空', 'home', false, false, null));
    }
    if (union && !mobile) {
      prompt(
        TLang('请输入取票手机号', 'home', false, false, null),
        '',
        [
          { text: TLang('取消', 'home', false, false, null) },
          {
            text: TLang('确定', 'home', false, false, null),
            onPress: (value) =>
              new Promise((resolve, reject) => {
                if (!rule.mobile.test(value)) {
                  setTimeout(() => {
                    reject();
                    Toast.info(TLang('请填写正确手机号', 'home', false, false, null));
                  }, 1000);
                } else {
                  setMobile(value);
                  if (isCheckUser) {
                    setShowCertificationModal(true);
                  } else {
                    toLockSeat(null, value);
                  }
                  resolve('');
                }
              })
          }
        ],
        'default',
        mobile,
        [TLang('请输入取票手机号', 'home', false, false, null)],
      );
    } else {
      if (isCheckUser) {
        setShowCertificationModal(true);
      } else {
        toLockSeat(null);
      }
    }
  };
  // 点击确认订单 ，去锁座
  const toLockSeat = (user: any, mobileVal = '') => {
    if (timeoutFlag) {
      return setTimeoutModal(true);
    }
    let c_user: any = {};
    if (isCheckUser) {
      setShowCertificationModal(false);
      c_user = getSessonStorage('u');
      c_user = JSON.parse(c_user);
      if (!c_user) {
        return Toast.info(TLang('实名信息读取错误', 'home', false, false, null));
      }
    }
    // Toast.loading(TLang('加载中', 'home', false, false, null), 0);
    increaseLoading();

    if (lockTime) {
      clearTimeout(lockTime);
    }

    // eslint-disable-next-line
    lockTime = setTimeout(() => {
      requstLockSeats(
        dataSource,
        selSeats,
        props.movieSession,
        union ? props.unionConfig : null,
        c_user,
        mobile || mobileVal || passwordInfo?.mobile,
        shadow,
      ).then((res) => {
        setTimeout(() => decreaseLoading(), 100);
        if (res.Status === 2226435) {
          // error
          Toast.info(res.Message || '很抱歉的通知您，当前系统正在维护，持续5分钟左右，请您稍等片刻');
        } else if (res.Status == 200019) {
          setRiskAccountMessage(
            res.Message || TLang('您的账户被识别为异常账户，当前订单无法完成支付，账户中的卡券暂时无法使用，请您联系客服获取进一步的信息。给您带来不便，敬请谅解！', 'home', false, false, null)
          );
          setShowRiskAccountModal(true);
        } else if (res.Status !== 0) {
          // error
          setTimeoutModal(true);
        } else {
          const { orderSn, purchaseLimitDTO } = res.Data;
          if (purchaseLimitDTO?.isGrey && !purchaseLimitDTO?.passFlag) {
            setPurchaseLimitInfo(res?.Data?.purchaseLimitDTO);
            setPurchaseLimitModal(true);
          } else {
            toComfirmOrder(orderSn);
          }
        }
        if (lockTime) {
          clearTimeout(lockTime);
        }
      });
    }, 100);
  };

  useEffect(() => {
    window.onpopstate = (e) => {
      if(window.location.pathname == '/newmovie/movieSeat') {
        const orderInfo: any = JSON.parse(sessionStorage.getItem('movie-seat-orderSn-h5') || '{}');
        if(orderInfo?.orderSn) {
          sessionStorage.removeItem('movie-seat-orderSn-h5');
          api.getOrderCancel(orderInfo?.orderSn).then((res) => {
            gioClick('电影-选座页面', {
              pagename: '选座页面',
              channle: '电影',
              modulename: '释放座位',
              elementname: '取消订单',
              contentTitle: orderInfo?.cinemaName,
              contentSubTitle: orderInfo?.movieName,
              content: orderInfo?.showStartTime,
              orderNum: orderInfo?.orderSn
            });
            window.location.reload();
          }).catch((error) => {
            window.location.reload();
          });
        }
      }
    };
  }, []);

  const toComfirmOrder = (res) => {
    sessionStorage.setItem('movie-seat-orderSn-h5', JSON.stringify({
      cinemaName: dataSource?.cinemaName,
      movieName: dataSource?.movieName,
      showStartTime: dataSource?.showDateTime,
      orderSn: res
    }));
    router.push({
      pathname: '/order/confirm',
      query: {
        orderSn: res
      }
    });
  };

  const getHeight = () => {
    const brand = judgeBrand(navigator.userAgent.toLowerCase());
    // console.log('navigator.userAgent.toLowerCase()', navigator.userAgent.toLowerCase(), 'device.isSafari():', device.isSafari(), device.isChrome(), document.documentElement.clientHeight, window.innerHeight);
    if (device.isSafari() && device.isIOS()) {
      // console.log('1111122222');
      return { height: document.documentElement.clientHeight };
    } else if (brand == 'huawei' && !BFD_checkApp()) {
      // return window.innerHeight;
      // console.log('22222333333');
      return { height: document.documentElement.clientHeight };
    } else if (device.isChrome() && !BFD_checkApp()) {
      // console.log('44444555555');
      return { height: document.documentElement.clientHeight };
    } else {
      // console.log('3333344444');
      return {};
    }
  };

  return (
    <Context.Provider value={{ state, dispatch: cdispatch }}>
      {isEmpty && lowPriceTag ? (
        <EmptyRefer />
      ) : (
        <div className={styles.movieSeat} id="movieSeat" style={getHeight()}>
          <NavBar
            text={dataSource?.cinemaName}
            textStyles={{ color: '#999' }}
            backAction={goBack}
            initColor="rgba(85,99,113,1)"
            targetColor="rgba(85,99,113,1)"
            targetBgColor="#FFF"
            opacity={1}
          />

          <div className={styles.movieInfo}>
            <div className={styles.name}>
              {dataSource?.movieName && lowPriceTag ? (
                <DFDiscount style={{ marginRight: '0.1rem' }} />
              ) : null}
              {dataSource?.movieName}
            </div>
            <div className={styles.info}>{getSessionText()}</div>
          </div>
          <DFTipsMsg time={dataSource.showDateTime}></DFTipsMsg>
          {dataSource && sortPrices && isMulPrice ? (
            <MulPriceArea
              lowPriceTag={lowPriceTag}
              sortPrices={sortPrices}
              activeColor={activeColor}
              unionConfig={props.unionConfig}
              onClick={colorHandle}
            />
          ) : null}

          {newData.length ? (
            <>
              {dataSource?.floors?.length <=0 ? <ReStage
                site={newData}
                leftIndexs={leftIndexs}
                maxSit={
                    dataSource?.purchaseLimitDTO.isGrey
                      ? dataSource?.purchaseLimitDTO?.maxPurchaseNum
                      : dataSource?.maxPurchaseNum
                  }
                siteEvent={getSiteHandler}
                hallName={hallName}
                love={dataSource.existLoveSeat}
                single={isMulPrice}
                activeIndex={activeColor}
                                                />
                  :
              <ReStageFloors
                key={currentFloor?.id}
                leftIndexs={leftIndexs}
                currentFloorId={currentFloor?.id}
                site={newData}
                floors={dataSource.floors || []}
                callback={(floor) => {
                      setCurrentFloor(floor);
                    }}
                selectedSeats={selSeats}
                maxSit={
                      dataSource?.purchaseLimitDTO.isGrey
                        ? dataSource?.purchaseLimitDTO?.maxPurchaseNum
                        : dataSource?.maxPurchaseNum
                    }
                siteEvent={getSiteHandler}
                hallName={hallName}
                love={dataSource.existLoveSeat}
                single={isMulPrice}
                activeIndex={activeColor}
              />}
              <SiteList
                data={selSeats}
                lowPriceTag={lowPriceTag}
                maxSit={dataSource?.maxPurchaseNum}
                purchaseLimitDTO={dataSource?.purchaseLimitDTO}
                deleItem={toDeleteSitItem}
              />
            </>
          ) : null}
          {total > 0 ? (
            <div className={`${styles.btn} ${styles.active}`} onClick={clickSelectSeatBtnHandle}>
              <DfPrice
                price={total}
                iconCls="gw"
                textStyles={{ fontSize: '0.36rem', fontWeight: 500, marginRight: '0.12rem' }}
              >
                <span>{TLang('确认选座', 'home', false, false, null)}</span>
              </DfPrice>
            </div>
          ) : (
            <div className={`${styles.btn}`}>
              <span>{TLang('请先选座', 'home', false, false, null)}</span>
            </div>
          )}
          <DfModal
            show={backModal}
            // img={notieImg}
            desc={TLang('返回后，您选中的座位将不再保留', 'home', false, false, null)}
            close={() => setBackModal(false)}
            left={{ text: TLang('返回', 'home', false, false, null), action: backHandle }}
            right={{
              text: TLang('继续选座', 'home', false, false, null),
              action: () => setBackModal(false)
            }}
          />
          {/* <DfCertificationModal show={showCertificationModal}
          close={() => setShowCertificationModal(false)}
          left={{text:'再看看', action:() => {setShowCertificationModal(false);}}}
          right={{text:'确认', action:(userInfo) => {toLockSeat(userInfo);}}}
        /> */}
          <PurchaseLimitModal
            setPurchaseLimitModal={setPurchaseLimitModal}
            purchaseLimitModal={purchaseLimitModal}
            purchaseLimitInfo={purchaseLimitInfo}
            union={union}
            companyOrderType={companyOrderType}
            unionCode={unionCode}
            aggOrderH5Url={aggOrderH5Url}
          />
          <Modal
            visible={timeoutModal}
            transparent
            maskClosable={false}
            onClose={() => {}}
            title={`${
              timeoutFlag
                ? TLang('选座超时，请在10分钟内完成选座', 'home', false, false, null)
                : TLang('锁定座位失败，请重新选座', 'home', false, false, null)
            }`}
            className="tout"
            wrapClassName="timeoutmldal"
            footer={[
              {
                text: TLang('我知道了', 'home', false, false, null),
                onPress: () => {
                  window.location.reload();
                }
              }
            ]}
          />
          {/** 绑定手机号弹框*/}
          <Modal
            visible={showBindModal}
            transparent
            maskClosable={false}
            onClose={() => setShowBindModal(false)}
            title={'绑定手机号'}
            className={styles.bindModal}
          >
            <div className={styles.desc}>
              <p>电影购票需完善手机号信息，请绑定手机号后购票</p>
            </div>
            <div className={styles.footer}>
              <div
                className={styles.cancle}
                onClick={() => {
                  setShowBindModal(false);
                  goBack();
                }}
              >
                {TLang('返回', 'home', false, false, null)}
              </div>
              <div
                className={styles.confirm}
                onClick={() => {
                  setShowBindModal(false);
                  setIsShowOrHide(true);
                }}
              >
                {TLang('立即绑定', 'home', false, false, null)}
              </div>
            </div>
          </Modal>
          <Modal
            visible={showOrderPop}
            transparent
            maskClosable={false}
            onClose={() => setShowOrderPop(false)}
            title={TLang('已有待支付订单，请先支付', 'home', false, false, null)}
            className={styles.bindModal}
          >
            <div className={styles.unpayContent}>
              <div className={styles.unpayContentDesc}>
                {TLang('影片', 'drawer', false, false, null)}：{unpayOrderInfo?.movieName}
              </div>
              <div className={styles.unpayContentDesc}>
                {TLang('影院', 'drawer', false, false, null)}：{unpayOrderInfo?.cinemaName}
              </div>
              <div className={styles.unpayContentDesc}>
                {TLang('场次', 'drawer', false, false, null)}：{getModalText()}
              </div>
            </div>
            <div className={styles.footer}>
              <div
                className={styles.cancle}
                onClick={() => {
                  setShowOrderPop(false);
                  gioClick('电影-选座页面', {
                    pagename: '选座页面',
                    channle: '电影',
                    modulename: '订单提示弹窗',
                    elementname: '取消订单',
                    contentTitle: unpayOrderInfo?.cinemaName,
                    contentSubTitle: unpayOrderInfo?.movieName,
                    content: unpayOrderInfo?.showStartTime,
                    orderNum: unpayOrderInfo?.orderSn
                  });
                  api.getOrderCancel(unpayOrderInfo?.orderSn).then((res) => {
                    if (res) {
                      Toast.info(TLang('取消订单成功', 'home', false, false, null));
                      setTimeout(() => {
                        window.location.reload();
                      }, 1500);
                    }
                  });
                }}
              >
                {TLang('取消订单', 'home', false, false, null)}
              </div>
              <div
                className={styles.confirm}
                onClick={() => {
                  setShowOrderPop(false);
                  gioClick('电影-选座页面', {
                    pagename: '选座页面',
                    channle: '电影',
                    modulename: '订单提示弹窗',
                    elementname: '去支付',
                    contentTitle: unpayOrderInfo?.cinemaName,
                    contentSubTitle: unpayOrderInfo?.movieName,
                    content: unpayOrderInfo?.showStartTime,
                    orderNum: unpayOrderInfo?.orderSn
                  });
                  router.push({
                    pathname: '/order/status',
                    query: {
                      orderSn: unpayOrderInfo?.orderSn
                    }
                  });
                }}
              >
                {TLang('去支付', 'home', false, false, null)}
              </div>
            </div>
          </Modal>
          <Modal
            visible={showRiskAccountModal}
            transparent
            maskClosable={false}
            onClose={() => setShowRiskAccountModal(false)}
            wrapClassName="riskAccountModal"
            footer={[
              {
                text: TLang('知道了', 'home', false, false, null),
                onPress: () => setShowRiskAccountModal(false)
              }
            ]}
          >
            <div className={styles.riskAccountContent}>{riskAccountMessage}</div>
          </Modal>

          {isShowOrHide && (
            <PayPassword
              isShowOrHide={isShowOrHide}
              isOnlyPhone
              // intereInfo={interestsInfo}
              createOrderCbk={() => {
                // goNextPayBill();
                setIsShowOrHide(false);
                getUserInfo();
              }}
              onClose={() => {
                setIsShowOrHide(false);
                setShowBindModal(true);
                // getUserInfo();
              }}
              userInfo={passwordInfo}
            ></PayPassword>
          )}
        </div>
      )}
    </Context.Provider>
  );
};

const mapStateToProps = ({ cinema, initData }) => ({
  ...cinema,
  unionConfig: initData.unionConfig
});

export default connect(mapStateToProps)(MovieSeat);
